module.exports = __webpack_public_path__ + "static/media/walle.43d704b9.svg";